var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEducationSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8356_4979)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.4996 25.8219C21.3207 25.8219 21.1422 25.7772 20.9806 25.6881L0.55599 14.4342C0.21328 14.2454 0 13.8851 0 13.4933C0 13.1016 0.21285 12.7408 0.55556 12.5521L20.9806 1.27446C21.3039 1.09601 21.6969 1.09601 22.0199 1.27446L42.4449 12.5521C42.788 12.7413 43.0004 13.102 43.0004 13.4933C43.0004 13.8846 42.7871 14.2454 42.444 14.4342L22.0181 25.6881C21.8569 25.7772 21.6784 25.8219 21.4996 25.8219ZM3.30068 13.4921L21.4996 23.5197L39.6989 13.4921L21.5 3.44338L3.30068 13.4921Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5208 23.5259C6.92697 23.5259 6.4458 23.0447 6.4458 22.4509V17.659C6.4458 17.0652 6.92697 16.584 7.5208 16.584C8.11463 16.584 8.5958 17.0652 8.5958 17.659V22.4509C8.5958 23.0447 8.11463 23.5259 7.5208 23.5259Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4759 23.5259C34.882 23.5259 34.4009 23.0447 34.4009 22.4509V17.659C34.4009 17.0652 34.882 16.584 35.4759 16.584C36.0697 16.584 36.5509 17.0652 36.5509 17.659V22.4509C36.5509 23.0447 36.0697 23.5259 35.4759 23.5259Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4958 33.3324C13.1972 33.3324 6.4458 28.6557 6.4458 22.907C6.4458 22.3132 6.92697 21.832 7.5208 21.832C8.11463 21.832 8.5958 22.3132 8.5958 22.907C8.5958 27.4698 14.3827 31.1824 21.4958 31.1824C28.6089 31.1824 34.3958 27.4698 34.3958 22.907C34.3958 22.3132 34.877 21.832 35.4708 21.832C36.0646 21.832 36.5458 22.3132 36.5458 22.907C36.5458 28.6557 29.7944 33.3324 21.4958 33.3324Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5063 19.8205C11.1214 19.8205 10.7495 19.6133 10.5564 19.2499C10.2777 18.7258 10.4768 18.0747 11.001 17.7961L20.9409 12.5127C21.4651 12.234 22.1156 12.4331 22.3947 12.9573C22.6738 13.4815 22.4743 14.1325 21.9501 14.4111L12.0098 19.6945C11.849 19.7801 11.6765 19.8205 11.5063 19.8205Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3444 36.6486C10.7506 36.6486 10.2694 36.1674 10.2694 35.5736V19.3406C10.2694 18.7468 10.7506 18.2656 11.3444 18.2656C11.9382 18.2656 12.4194 18.7468 12.4194 19.3406V35.5736C12.4194 36.167 11.9382 36.6486 11.3444 36.6486Z",
    fill: "#F9C416"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.545 41.8617H9.1375C8.54367 41.8617 8.0625 41.3805 8.0625 40.7867V37.8842C8.0625 36.0765 9.5331 34.6055 11.3412 34.6055C13.1494 34.6055 14.62 36.0765 14.62 37.8842V40.7867C14.62 41.3801 14.1388 41.8617 13.545 41.8617ZM10.2125 39.7117H12.47V37.8842C12.47 37.262 11.9635 36.7555 11.3412 36.7555C10.719 36.7555 10.2125 37.2616 10.2125 37.8842V39.7117Z",
    fill: "#F9C416"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8356_4979"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 43,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducationSelected);
export default __webpack_public_path__ + "static/media/educationSelected.e38a2c1f3b447e0afaf2f80b84d67ea7.svg";
export { ForwardRef as ReactComponent };